import './App.css';
import Header from './components/Header';
import About from './components/About';
import Skills from './components/Skills';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import ErrorBoundary from './components/ErrorBoundary';
import { useEffect } from 'react';
import { Analytics } from '@vercel/analytics/react';

const ACCESS_EMAIL = process.env.REACT_APP_EMAIL || 'palahuddinalkhalid@gmail.com';

// Main App component
function App() {
  // Add mousemove and mouseleave event listeners to update CSS variables and toggle spotlight effect
  useEffect(() => {
    const handleMouseMove = (e) => {
      document.documentElement.style.setProperty('--mouse-x', `${e.clientX}px`);
      document.documentElement.style.setProperty('--mouse-y', `${e.clientY}px`);
      document.body.classList.add('spotlight');
    };

    const handleMouseLeave = () => {
      document.body.classList.remove('spotlight');
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);

    // Cleanup event listeners on unmount
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  return (
    <div className="App">
      <div className="container">
        {/* Sidebar with profile and navigation */}
        <aside className="sidebar">
          <ErrorBoundary>
            <Header />
          </ErrorBoundary>
        </aside>

        {/* Main content area with all sections */}
        <main className="main-content main-content-locked" aria-label="Portfolio details are temporarily restricted">
          <div className="locked-content" aria-hidden="true">
            <ErrorBoundary>
              <About />
            </ErrorBoundary>
            <ErrorBoundary>
              <Skills />
            </ErrorBoundary>
            <ErrorBoundary>
              <Experience />
            </ErrorBoundary>
            <ErrorBoundary>
              <Projects />
            </ErrorBoundary>
            <ErrorBoundary>
              <Contact />
            </ErrorBoundary>
          </div>

          <section className="access-panel hacker-access-panel" aria-labelledby="access-panel-title">
            <div className="access-terminal-bar" aria-hidden="true">
              <span></span>
              <span></span>
              <span></span>
              <code>portfolio://restricted</code>
            </div>
            <span className="access-eyebrow">Access layer active</span>
            <h2 id="access-panel-title">ACCESS RESTRICTED</h2>
            <div className="access-terminal-lines" aria-hidden="true">
              <code>&gt; scanning public profile... ok</code>
              <code>&gt; project case studies... encrypted</code>
              <code>&gt; temporary unlock requires approval</code>
            </div>
            <p>
              Portfolio details are hidden while the showcase is being rebuilt. Request a temporary unlock and I&apos;ll send access directly.
            </p>
            <div className="access-actions">
              <a
                className="access-request-link"
                href={`mailto:${ACCESS_EMAIL}?subject=Request%20access%20to%20portfolio&body=Hi%20Al%20Khalid,%0A%0AI%27d%20like%20to%20request%20temporary%20access%20to%20your%20portfolio.%0A%0AThanks!`}
              >
                Request access key
              </a>
              {/* <span className="access-note">Left profile node remains public.</span> */}
            </div>
          </section>
        </main>
      </div>
      <Analytics />
    </div>
  );
}

export default App;
